/*
 * Carrito lateral Salty — inserta los métodos de pago al pie del carrito.
 *
 * El markup lo genera Liquid en <template id="sd-cart-pay"> (ver theme.liquid),
 * con los logos que están cargados en Configuración del tema. Acá solo se
 * clona dentro del pie del drawer. Se hace así, y no agregando un bloque a
 * sections/cart-drawer.liquid, para dejar ese archivo del tema sin tocar.
 */
(function () {
  'use strict';

  function insertar() {
    var tpl = document.getElementById('sd-cart-pay');
    if (!tpl) return;

    var pies = document.querySelectorAll('.hdt-dialog-drawer--cart .hdt-mini-cart__bottom-wrap');
    for (var i = 0; i < pies.length; i++) {
      var pie = pies[i];
      if (pie.querySelector('.sd-pay')) continue;      /* ya está puesto */
      var nodo = tpl.content.cloneNode(true);
      pie.appendChild(nodo);
    }
  }

  /* El carrito se re-renderiza al agregar, quitar o cambiar cantidades, así
     que se vuelve a chequear ante cualquier cambio dentro del drawer. */
  function observar() {
    var drawer = document.querySelector('.hdt-dialog-drawer--cart');
    if (!drawer) return false;
    insertar();
    new MutationObserver(function () { insertar(); })
      .observe(drawer, { childList: true, subtree: true });
    return true;
  }

  function init() {
    if (observar()) return;
    /* El drawer puede entrar al DOM después; se espera a que aparezca. */
    var obs = new MutationObserver(function () {
      if (observar()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
